// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import RoomsTable from "./RoomsTable";
import RoomCreateOrEdit from "./RoomCreateOrEdit";

// MARK: Router
import { Route, Switch } from "react-router-dom";

// MARK: Stores
import AuthStore from "../../../stores/AuthStore";

// MARK: Resources
import strings from "../../../resources/strings";

interface IProps {
	authStore: AuthStore;
}

@inject("authStore")
@observer
export default class Rooms extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.authStore.authenticate();
	};

	public render() {
		return (
			<div className="rooms">
				<Switch>
					<Route exact={true} path="/dashboard/rooms/editor" component={RoomCreateOrEdit} />
					<Route path="/dashboard/rooms/editor/:roomId" component={RoomCreateOrEdit} />
					<Route path="/dashboard/rooms" component={RoomsTable} />
				</Switch>
			</div>
		);
	}
}
